import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger
} from '@repo/ui/accordion'
import { Button } from '@repo/ui/button'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
	DialogTrigger
} from '@repo/ui/dialog'
import { useTranslation } from '@/lib/i18n'

export function MrBookImportInstructions() {
	const { t } = useTranslation()
	return (
		<Dialog>
			<DialogTrigger render={<Button size='sm' variant='link' />}>
				{t('po:export.mrbook_instructions.title')}
			</DialogTrigger>
			<DialogContent className='max-h-[calc(100dvh-2rem)] overflow-y-auto'>
				<DialogHeader>
					<DialogTitle>
						{t('po:export.mrbook_instructions.title')}
					</DialogTitle>
					<DialogDescription>
						{t('po:export.mrbook_instructions.description')}
					</DialogDescription>
				</DialogHeader>
				<MrBookImportSteps />
			</DialogContent>
		</Dialog>
	)
}

export function MrBookImportSteps() {
	const { t } = useTranslation()
	return (
		<div className='space-y-4'>
			<ol className='space-y-4'>
				{(['open', 'reading', 'order', 'view'] as const).map(
					(step, index) => (
						<li className='flex items-start gap-3' key={step}>
							<span className='flex size-6 shrink-0 items-center justify-center rounded-full bg-muted text-muted-foreground text-xs'>
								{index + 1}
							</span>
							<div className='space-y-1 text-sm'>
								<p className='font-medium'>
									{t(
										`po:export.mrbook_instructions.${step}_title`
									)}
								</p>
								<p className='text-muted-foreground'>
									{t(`po:export.mrbook_instructions.${step}`)}
								</p>
							</div>
						</li>
					)
				)}
			</ol>
			<Accordion>
				<AccordionItem value='terminal-setup'>
					<AccordionTrigger className='py-2'>
						{t('po:export.mrbook_instructions.setup_title')}
					</AccordionTrigger>
					<AccordionContent>
						<p>{t('po:export.mrbook_instructions.setup')}</p>
					</AccordionContent>
				</AccordionItem>
			</Accordion>
		</div>
	)
}
